module.exports = __webpack_public_path__ + "static/media/2022_2A3A9545.211dae6d.jpg";